import { render, staticRenderFns } from "./ApplicationListPage.vue?vue&type=template&id=36071f00&"
import script from "./ApplicationListPage.vue?vue&type=script&lang=js&"
export * from "./ApplicationListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports